import React from 'react';

import ImageIcon from '@material-ui/icons/ImageRounded';
import MovieIcon from '@material-ui/icons/MovieRounded';
import DescriptionIcon from '@material-ui/icons/DescriptionRounded';
import { makeStyles, Link } from '@material-ui/core';

const getIcon = (type) => {
  switch (type) {
    case 'image/png':
    case 'image/gif':
    case 'image/jpeg':
    case 'image/jpg':
      return ImageIcon;
    case 'video/mp4':
    case 'video/3gpp':
    case 'video/quicktime':
    case 'video/x-msvideo':
      return MovieIcon;
    default:
      return DescriptionIcon;
  }
};

const useStyles = makeStyles((theme) => ({
  icon: {
    marginRight: theme.spacing(1),
  },
}));

export const S3File = ({ record, source }) => {
  const s3Object = (record && source && record[source]) || record;
  const Icon = getIcon(s3Object.type);
  const classes = useStyles();
  return (
    <>
      <Icon
        titleAccess={`Icon for file type ${s3Object.type || 'unknown'}`}
        className={classes.icon}
      />
      <Link
        href={s3Object.key}
        title={`Open ${s3Object.key}`}
        target="_blank"
      >{`${s3Object.key}${s3Object.level ? ` - ${s3Object.level}` : ''}`}</Link>
    </>
  );
};
